import { useState, useRef, useEffect, useMemo } from 'react'

/**
 * 产生可用于组件的实例变量的hook，类似于使用Class组件的this。
 * 传入组件函数的参数props
 * 
 * 返回: {
 * me:类似于this, 初始可用{state, props, setState}，
 * setState: 与me.setState相同
 * }
 * @param {*} props  * 一般为组件函数参数，在该hook之后 me.props即为最新的props
 * @param {*} init 初始化无参函数，返回对象中所有成员将任务me的成员, 非函数无效
 * @param {*} clean 清理函数，在卸载时调用
 */
export const useInstData = (props: any, init = undefined as any, clean = undefined as any) => {
	const [, _refresh] = useState({})
	const ref: any = useRef(useMemo(() => ({
		state: {},
		...(init && typeof init == 'function' && ({ ...init() }) || { ...init }),
		props: props || {},
		// mounted: false, unmounted: false,
		setState: (nv?: object | Function) => {
			if (ref.current.unmounted)
				return
			ref.current.state = ref.current.state || {}
			typeof nv == 'function' && (nv = nv(ref.current.state, ref.current.props))
			if (!nv || typeof nv != 'object')
				return
			ref.current.state = { ...ref.current.state || {}, ...nv }
			_refresh({})
		}
	}), []))
	// WangWei: 2020/6/3 修改使用useState做一次性同步工作为判断 ref.current是否为空
	// // useState(() => {
	// if (!ref.current) {
	// 	(ref.current as any) = init && typeof init == 'function' && ({ ...init() }) || { ...init }
	// 	ref.current.state = ref.current.state || {}
	// 	ref.current.setState = (nv) => {
	// 		if (ref.current.unmounted) return
	// 		ref.current.state = ref.current.state || {}
	// 		typeof nv == 'function' && (nv = nv(ref.current.state, ref.current.props))
	// 		if (!nv || typeof nv != 'object')
	// 			return
	// 		ref.current.state = { ...ref.current.state || {}, ...nv }
	// 		_refresh({})
	// 	}
	// }
	// // })
	useEffect(() => (ref.current.mounted = true, () => { clean && typeof clean === 'function' && clean(), ref.current.unmounted = true }), [])

	const { current: me, current: { setState } } = ref
	me.props = props || {}
	return { me, setState }
}